<template>
  <GobSection id="como-empezar" tono="alterna">
    <div class="max-w-3xl">
      <h2 class="text-gob-5 leading-tight font-extrabold tracking-gob-tighter text-balance text-main">
        Un camino claro, a la medida de su entidad.
      </h2>
    </div>

    <!-- Línea de tiempo: horizontal desde 768 px, vertical en móvil. El orden lo da la propia <ol>. -->
    <ol class="mt-14 grid gap-10 md:grid-cols-4 md:gap-8">
      <li
        v-for="(paso, indice) in pasos"
        :key="paso.titulo"
        class="paso relative pl-16 md:pl-0 md:pt-18"
        :style="{ '--paso-color': paso.color, '--paso-siguiente': colorSiguiente(indice) }"
      >
        <span
          class="paso-nodo absolute top-0 left-0 grid size-12 place-items-center rounded-full border-2 bg-surface text-gob-2 font-black"
          aria-hidden="true"
        >
          {{ indice + 1 }}
        </span>
        <h3 class="pt-2.5 text-gob-3 leading-tight font-extrabold tracking-gob-tight text-main md:pt-0">{{ paso.titulo }}</h3>
        <p class="mt-3 max-w-sm leading-relaxed text-[#495057]">{{ paso.texto }}</p>
      </li>
    </ol>

    <div class="mt-12">
      <GobButton to="/como-empezar" con-flecha>Ver el modelo de trabajo</GobButton>
    </div>
  </GobSection>
</template>

<script>
import GobButton from '@/components/GobButton.vue'
import GobSection from '@/components/GobSection.vue'

const PASOS = [
  {
    titulo: 'Diagnóstico',
    texto: 'Entendemos cómo gestiona hoy su plan y su atención social.',
    color: 'var(--color-primary)'
  },
  {
    titulo: 'Implementación',
    texto: 'Configuramos Gob 24/7 según sus procesos y capacitamos a su equipo.',
    color: 'var(--color-signal-data)'
  },
  {
    titulo: 'Acompañamiento',
    texto: 'Seguimos a su lado para que las metas se cumplan.',
    color: 'var(--color-signal-human)'
  },
  {
    titulo: 'Evolución',
    texto: 'Medimos resultados y ampliamos la plataforma para el siguiente ciclo de gestión.',
    color: 'var(--color-electric)'
  }
]

/**
 * HomePasos
 * Resumen de "Cómo empezar" como línea de tiempo de cuatro pasos unidos por un conector
 * que funde el color de cada paso con el del siguiente.
 */
export default {
  name: 'HomePasos',
  components: { GobButton, GobSection },
  data() {
    return { pasos: PASOS }
  },
  methods: {
    colorSiguiente(indice) {
      const siguiente = PASOS[indice + 1]
      return siguiente ? siguiente.color : PASOS[indice].color
    }
  }
}
</script>

<style scoped>
.paso-nodo {
  border-color: var(--paso-color);
  color: var(--paso-color);
  transition:
    background-color var(--duration-gob) var(--ease-gob-out),
    color var(--duration-gob) var(--ease-gob-out);
}

/* Al pasar sobre un paso, su número se rellena con el color del paso. */
.paso:hover .paso-nodo {
  background-color: var(--paso-color);
  color: #FFFFFF;
}

/* Conector hasta el nodo siguiente, con 8 px de aire en cada extremo. */
.paso:not(:last-child)::after {
  content: '';
  position: absolute;
  top: 56px;
  bottom: -32px;
  left: 23px;
  width: 2px;
  background: linear-gradient(var(--paso-color), var(--paso-siguiente));
}

@media (min-width: 768px) {
  .paso:not(:last-child)::after {
    top: 23px;
    right: -24px;
    bottom: auto;
    left: 56px;
    width: auto;
    height: 2px;
    background: linear-gradient(90deg, var(--paso-color), var(--paso-siguiente));
  }
}
</style>
